<template>
  <div v-if="current">
    <v-card width="100%">
      <v-card-title>Requisição: {{ current.inicio | formatDate}}</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-9 col-sm-1">
              <v-select label="Operadora" v-model="current.operadora" :items="operadoras" outlined dense disabled></v-select>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-select label="Tipo" v-model="current.tipo" :items="tipos" outlined dense disabled></v-select>
            </div>
            <div class="col-md-12 col-sm-1">
              <v-text-field label="Cliente" v-model="current.cliente" outlined dense disabled></v-text-field>
            </div>
            <div class="col-md-6 col-sm-1">
              <v-text-field label="Endereço" v-model="current.endereco" outlined dense disabled></v-text-field>
            </div>
            <div class="col-md-2 col-sm-1">
              <v-text-field label="Bairro" v-model="current.bairro" outlined dense disabled></v-text-field>
            </div>
            <div class="col-md-2 col-sm-1">
              <v-text-field label="Cidade" v-model="current.cidade" outlined dense disabled></v-text-field>
            </div>
            <div class="col-md-2 col-sm-1">
              <v-text-field label="CEP" v-model="current.cep" outlined dense disabled></v-text-field>
            </div>
            <div class="col-md-12 col-sm-1">
              <v-text-field label="Mapa" v-model="current.maps" outlined dense disabled></v-text-field>
            </div>
            <div class="col-md-12 col-sm-1">
              <v-text-field label="Comentário" v-model="current.comentario" outlined dense disabled></v-text-field>
            </div>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card width="100%">
      <v-card-title>Resposta: <v-chip :color="colorStatus(current)" text-color="white" small>{{ current | formatStatus }}</v-chip></v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-4 col-sm-1">
              <v-text-field label="CTO" v-model="current.cto" outlined dense disabled></v-text-field>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-text-field label="Porta" v-model="current.porta" outlined dense disabled></v-text-field>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-select label="ONU" v-model="current.onu" :items="onu" outlined dense disabled></v-select>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-text-field label="Metragem" v-model="current.metragem" outlined dense disabled></v-text-field>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-text-field label="Postes" v-model="current.postes" outlined dense disabled></v-text-field>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-select label="Classificação" v-model="current.classificacao" :items="classificacao" outlined dense disabled></v-select>
            </div>
            <div class="col-md-12 col-sm-1">
              <v-text-field label="Observação" v-model="current.observacao" outlined dense disabled></v-text-field>
            </div>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import api from "../../api/index.js";
export default {
  data: () => ({
    current: null,
    onu: [
      { text: "Parks", value: 1 },
      { text: "Huawei", value: 2 }
    ],
    classificacao: [
      { text: "Comum", value: 1 },
      { text: "Longo", value: 2 },
      { text: "Complexo", value: 3 },
      { text: "Especial", value: 4 }
    ],
    tipos: [
      { text: "Nova Instalação", value: 1 },
      { text: "Mudança de Endereço", value: 2 }
    ],
    operadoras: [
      { text: "Vivavox", value: 1 },
      { text: "Link1000 - CDM", value: 2 },
      { text: "Link1000 - CDO", value: 3 },
      { text: "G2", value: 4 }
    ]
  }),
  created: function() {
    this.load();
  },
  methods: {
    load: function() {
      var me = this;
      api
        .get("/viabilidade/open/" + this.$route.params.id)
        .then(function(response) {
          me.current = response.data;
        })
        .catch(function() {
          console.log("viabilidade fail");
        });
    },
    colorStatus: function(item){
      var color = "";
      if (item.status==1){
        color = "primary";
      }else if(item.status==2){
        color = "success";
      }else if(item.status==3){
        color = "error";
      }else if(item.status==4){
        color = "warning";
      }else if(item.status==5){
        color = "secondary";
      }
      return color;
    }
  },
  filters: {
    formatStatus: function(item){
      var text = "";
      if (item.status==1){
        text = "Aguardando";
      }else if(item.status==2){
        text = "Positiva";
      }else if(item.status==3){
        text = "Negativa";
      }else if(item.status==4){
        text = "Vistoria";
      }else if(item.status==5){
        text = "Rejeitada";
      }
      return text;
    }
  }
};
</script>